export const content = [
    {
        id: 1,
        text:
            '<p>How it works:</p>' +
            '<ul>' +
            '<li>When your order is approved, our customer service will reach out to explain the process</li>' +
            '<li>Samsung’s qualified technical services team will arrange a date with you to deliver and install the device</li>' +
            '<li>Your subscription will start on the date of installation</li>' +
            '</ul>'
    }
];
